











import FeedbackComponent from '@/components/base/FeedbackComponent'
import ShowDocumentsComponents from "@/components/dashboard/search-customer-service/ShowDocumentsComponents.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {Utils} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({
  components: {
    ShowDocumentsComponents
  }
})
export default class CRMContactAttachmentsMember extends FeedbackComponent {

  @Prop(Number) crmId!: number;

  @Action('getAttachmentMemberCrm', StoreNamespace.CUSTOMER_SERVICE) getAttachmentMemberCrm: any
  @Action('downloadAttachmentCrm', StoreNamespace.CUSTOMER_SERVICE) downloadAttachmentCrm: any

  private attachments: any[] = [];

  mounted() {
    if (this.crmId) {
      this.getAttachmentMemberCrm({
        requestorCallback: this,
        pathVariable: this.crmId
      });
    }
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'attachmentMemberCrm':
        this.attachments = data;
        break;
      case 'downloadAttachmentCrm':
        Utils.downloadFile(data.fileData, data.fileName, undefined , data.fileExtension)
        break;
    }
  }

  downloadAttachment(attachmentId: any) {
    this.downloadAttachmentCrm({
      requestorCallback: this,
      pathVariable: attachmentId
    })
  }
}


